import React from 'react';
import { Card, Button, Typography, Space } from 'antd';
import { CrownOutlined, ShoppingOutlined } from '@ant-design/icons';
import { useAuthStore } from '../stores/authStore';
import useConfigStore from '../stores/configStore';

const { Title, Text } = Typography;

const VipRestriction = ({ children }) => {
  const { user } = useAuthStore();
  const { membershipEnabled } = useConfigStore();

  // 权限检查函数
  const checkUserPermission = (user) => {
    // 会员付费关闭时（审核期），所有账号免费
    if (!membershipEnabled) {
      return true;
    }
    // 管理员始终有权限
    if (user?.role === 'admin') {
      return true;
    }

    // 检查是否是付费会员
    const paidMembers = ['VIP会员', '高级会员', '银卡会员', '金卡会员', '钻石会员'];
    if (paidMembers.includes(user?.member_level)) {
      return true;
    }

    // 检查试用期
    if (user?.trial_end_date) {
      const trialEndDate = new Date(user.trial_end_date);
      const now = new Date();
      return now <= trialEndDate;
    }

    return false;
  };

  // 检查用户权限
  const isVipUser = checkUserPermission(user);
  
  // 如果是VIP用户，正常显示内容
  if (isVipUser) {
    return children;
  }
  
  // 如果不是VIP用户，显示高级会员专享提示
  return (
    <div style={{ 
      padding: '40px 20px', 
      textAlign: 'center',
      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      minHeight: '60vh',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center'
    }}>
      <Card style={{ 
        maxWidth: '500px', 
        borderRadius: '16px',
        boxShadow: '0 8px 32px rgba(0,0,0,0.1)',
        border: 'none'
      }}>
        <Space direction="vertical" size="large" style={{ width: '100%' }}>
          <div>
            <CrownOutlined style={{ 
              fontSize: '48px', 
              color: '#ffd700',
              marginBottom: '16px'
            }} />
            <Title level={2} style={{ color: '#333', marginBottom: '8px' }}>
              高级会员专享
            </Title>
            <Text style={{ color: '#666', fontSize: '16px' }}>
              此功能仅对高级会员开放，升级会员即可享受完整功能
            </Text>
          </div>
          
          <div style={{ marginTop: '24px' }}>
            <Button 
              type="primary" 
              size="large"
              icon={<ShoppingOutlined />}
              style={{ 
                background: 'linear-gradient(45deg, #ff6b6b, #ee5a24)',
                border: 'none',
                borderRadius: '8px',
                height: '48px',
                fontSize: '16px',
                fontWeight: 'bold'
              }}
              onClick={() => {
                // 跳转到卡密商城
                window.open('/cardmall', '_blank');
              }}
            >
              立即升级会员
            </Button>
          </div>
          
          <div style={{ marginTop: '16px' }}>
            <Text style={{ color: '#999', fontSize: '14px' }}>
              VIP会员特权：解锁所有20个管理模块，享受完整功能体验
            </Text>
          </div>
        </Space>
      </Card>
    </div>
  );
};

export default VipRestriction;
